<template>
  <div>
    <button
      class="Button Button--tertiary"
      @click.prevent="showModal = true"
    >
      <span v-if="parentProfession === null">Pick a profession</span>
      <span v-else>Change profession</span>
    </button>
    <base-modal
      v-model="showModal"
      @base-modal:closed="closeModal"
    >
      <template #modal-body>
        <div
          v-for="(profession, index) in parentProfessions"
          :key="profession.id"
        >
          <div class="Radio-container">
            <rmp-radio
              :id="`profession+${index}`"
              v-model="parentProfession"
              :label="profession.text"
              :value="profession.value"
              :name="`profession+${profession.id}`"
              class="RadioButton-profession"
              @change="handleSelection(profession.value)"
            />
            <p
              v-if="profession.hint !== ''"
              class="Hint"
            >
              {{ profession.hint }}
            </p>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import rmpRadio from '@/components/form/radio-button';
import BaseModal from '@/components/modal/base-modal';

export default {

  // Component uses other components
  components: {
    BaseModal,
    rmpRadio,
  },
  props: {
    parentProfessions: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedProfession: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      fields: {
        parent_profession: this.selectedProfession,
      },
      fieldName: 'parent_profession',
    };
  },
  computed: {
    extraClasses() {
      return 'Modal--authOnly Modal--noSpacing';
    },
    parentProfession: {
      get() { return this.fields.parent_profession || this.selectedProfession; },
      set(profession) { this.fields.parent_profession = profession; },
    },
  },

  created() {
    this.$bus.$on('bus:global-modal:close', this.closeModal);
  },

  mounted() {
    document.addEventListener('keyup', (e) => {
      if (this.showModal && e.keyCode === 27) {
        this.closeModal();
      }
    });
  },

  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.emailOnly = false;
    },
    handleSelection(profession) {
      this.$emit('parent-profession-selection', profession);
      this.closeModal();
    },
  },
};
</script>
